import { forwardRef, useCallback, useImperativeHandle, useState } from "react"

const DynamicFormGenerator = forwardRef((props, ref) => {
  const { liftState, values, id, from, objectOfComponent, form } = props

  const [formKey, setFormKey] = useState({})
  const [openModal, setOpenModal] = useState(false)

  useImperativeHandle(
    ref,
    () => ({
      showFor(formKey) {
        setFormKey(formKey)
        setOpenModal(true)
      },
    }),
    []
  )

  let formSelector = useCallback(
    key => {
      let Component = objectOfComponent[key]
      return Component ? (
        <Component
          form={form}
          liftState={liftState}
          values={values}
          id={id}
          openModal={openModal}
          setOpenModal={setOpenModal}
          {...formKey?.config}
        />
      ) : null
    },
    [form, liftState, openModal, id, formKey, values, objectOfComponent]
  )

  return formSelector(formKey?.name)
})

export default DynamicFormGenerator
